<template>
  <div class="expand-code-wrapper" @click.stop="$emit('expand')">
    <span ref="btnText" class="text">查看全部</span>
  </div>
</template>

<script lang="ts">
import { Vue, Component } from 'vue-property-decorator'

@Component({
  name: 'ExpandCodeBtn'
})
export default class ExpandCodeBtn extends Vue {}
</script>

<style scoped lang="scss">
.expand-code-wrapper{
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 100;
    width: 100%;
    height: 40px;
    line-height: 40px;
    text-align: center;
  background-image: linear-gradient(to top,white, transparent);

  .text{
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    height: 32px;
    padding: 3px 10px;
    color: white;
    font-size: 14px;
    line-height: 32px;
    background: var(--motif-300);
    border-radius: 4px;
    cursor: pointer;
  }
}
</style>